import { getGenre } from "../../api/v1/genre/get"
import { Genre } from "./Genre"
import { GenreGetInputModel } from "../../api/v1/genre/GetInputModel"

export const fetchGenres = (): Promise<Genre[]> => {
  return getGenre(new GenreGetInputModel())
}
